import { render, staticRenderFns } from "./UseCase.vue?vue&type=template&id=2ea9cc0c&scoped=true"
import script from "./UseCase.vue?vue&type=script&lang=js"
export * from "./UseCase.vue?vue&type=script&lang=js"
import style0 from "./UseCase.vue?vue&type=style&index=0&id=2ea9cc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_-872774970/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9cc0c",
  null
  
)

export default component.exports